// This file was auto-generated by Fern from our API Definition.
export var BodyEditSimpleTestsetFromFile;
(function (BodyEditSimpleTestsetFromFile) {
    BodyEditSimpleTestsetFromFile.FileType = {
        Csv: "csv",
        Json: "json",
    };
})(BodyEditSimpleTestsetFromFile || (BodyEditSimpleTestsetFromFile = {}));
